import { Typography } from 'antd';
import styled from 'styled-components';

export const CardHistory = styled.div`
  border: 1px solid #000;
  border-radius: 4px;
  margin-bottom: 5rem;
  margin-top: 3rem;
`;

export const CardHistoryHead = styled.div`
  padding: 22px 24px;
`;

export const CardHistoryBody = styled.div`
  font-size: 18px;
  padding: 0 24px 24px;
`;

export const Title = styled(Typography.Title)`
  font-weight: 700;
  line-height: 1.1;
  font-size: 1.625rem;
  margin: 0 0 2rem;
  color: #333 !important;
`;
